import type { SVGProps } from 'react'

const LocationBasedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_170_31443)">
      <path
        d="M26.25 12.498C26.25 21.248 15 28.748 15 28.748C15 28.748 3.75 21.248 3.75 12.498C3.75 9.51436 4.93526 6.65288 7.04505 4.5431C9.15483 2.43331 12.0163 1.24805 15 1.24805C17.9837 1.24805 20.8452 2.43331 22.955 4.5431C25.0647 6.65288 26.25 9.51436 26.25 12.498Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.333 17.667V7.55C16.333 7.24624 16.5793 7 16.883 7H18.4498C18.7535 7 18.9998 7.24624 18.9998 7.55V17.667"
        stroke="#0066FF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.667 18.5V11.8156C13.667 11.5119 13.9132 11.2656 14.217 11.2656H15.7837C16.0875 11.2656 16.3337 11.5119 16.3337 11.8156V18.5"
        stroke="#0066FF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 17.6692V13.9523C11 13.6486 11.2462 13.4023 11.55 13.4023H13.1168C13.4205 13.4023 13.6668 13.6486 13.6668 13.9523V17.6692"
        stroke="#0066FF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 12C22 12.9193 21.8189 13.8295 21.4672 14.6788C21.1154 15.5281 20.5998 16.2997 19.9497 16.9497C19.2997 17.5998 18.5281 18.1154 17.6788 18.4672C16.8295 18.8189 15.9193 19 15 19C14.0807 19 13.1705 18.8189 12.3212 18.4672C11.4719 18.1154 10.7003 17.5998 10.0503 16.9497C9.40024 16.2997 8.88463 15.5281 8.53284 14.6788C8.18106 13.8295 8 12.9193 8 12"
        stroke="#0066FF"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_170_31443">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default LocationBasedIcon
